import React, { createContext, useContext } from "react";

const IconContext = createContext({
  resolveIcon: (symbol) => ""
});

export const useIconResolver = () => useContext(IconContext).resolveIcon;

export const IconProvider = ({ children, resolver }) => {
  return (
    <IconContext.Provider value={{ resolveIcon: resolver }}>
      {children}
    </IconContext.Provider>
  );
};
